import * as React from 'react';

interface CircleTextTypes {
	text?: number | string;
	size?: number;
}

const CircleText: React.FC<CircleTextTypes> = ({ text, size }) => {
	return (
		<div className="circle-text-wrapper" style={{ height: size, width: size }}>
			<div className="content">{text}</div>
		</div>
	);
};

export default CircleText;
